import React, { lazy } from 'react'
import { ConversionRateListing } from './ConversionRateListing'

const UOMRateListing = lazy(() =>
  import('./UOMRateListing').then(module => ({
    default: module.UOMRateListing,
  }))
)

// const UOMExchangeListing = lazy(() =>
//   import(
//     '@ifca-root//UOMExchange/UOMRateListing'
//   ).then(module => ({
//     default: module.UOMRateListing,
//   })),
// );

const uomRateRoutes = [
  {
    props: { exact: true, path: '/account-payable/general-setting/uom-rate' },
    component: <UOMRateListing />,
  },
  {
    props: {
      exact: true,
      path: '/account-payable/general-setting/uom-conversion',
    },
    component: <ConversionRateListing page="account-payable" />,
  },
  {
    props: {
      exact: true,
      path: '/general-purchase/general-setting/uom-conversion',
    },
    component: <ConversionRateListing page="general-purchase" />,
  },
  {
    props: {
      exact: true,
      path: '/inventory-control/general-setting/uom-conversion',
    },
    component: <ConversionRateListing page="inventory-control" />,
  },
]

export default uomRateRoutes
